import { request } from './request'

export function queryCalendar(year, month) {
  return request.post('/calendar/page', null, { params: { year, month } })
}

export function queryCalendarRange() {
  return request.get('/calendar/range')
}
